<template>
  <div id="app">
    <v-app>
      <router-view/>
    </v-app>
  </div>
</template>

<script>

import ApiService from '@/services/api.service'

export default {
  name: 'App',
  created: function () {
    ApiService.mountAuthenticationInterceptor()
  },
  unmounted () {
    ApiService.unmountAuthenticationInterceptor()
  }
}
</script>

<style lang="scss">
@import "./assets/sass/main.scss";

</style>
